/* import __COLOCATED_TEMPLATE__ from './inbox-color.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();